export default __webpack_public_path__ + "static/bg-01-bfd487b883a8a9058eb9ff418ae9ae98.jpg";